import { Input } from 'src/@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Switch } from 'src/@/components/ui/switch';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function ModalCustomField({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
  tipo,
  changeTipo,
  opcoes,
  changeOpcoes,
  obrigatorio,
  changeObrigatorio,
}) {
  const { t } = useTranslation('settings');
  const [novaOpcao, setNovaOpcao] = useState('');

  const adicionarOpcao = () => {
    if (novaOpcao.trim()) {
      changeOpcoes([...(opcoes || []), novaOpcao.trim()]);
      setNovaOpcao('');
    }
  };

  const removerOpcao = (index) => {
    changeOpcoes(opcoes.filter((_, i) => i !== index));
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
        <DialogHeader>
          <DialogTitle className={D.dialogTitle}>
            {action === 'Criar'
              ? t('funnel.customFields.modal.createTitle', 'Criar campo personalizado')
              : t('funnel.customFields.modal.editTitle', 'Editar campo personalizado')}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-5 py-2">
          <div className={D.field}>
            <label className={D.label}>{t('funnel.customFields.modal.nameLabel', 'Nome do campo')}</label>
            <Input
              onChange={changeNome}
              value={nome}
              placeholder={t('funnel.customFields.modal.namePlaceholder', 'Ex: Número da cotação')}
              className={D.input}
            />
          </div>
          <div className={D.field}>
            <label className={D.label}>{t('labels.type', 'Tipo', { ns: 'common' })}</label>
            <Select value={tipo} onValueChange={changeTipo}>
              <SelectTrigger className={D.select}>
                <SelectValue placeholder={t('funnel.customFields.modal.typePlaceholder', 'Selecione o tipo')} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="texto">{t('funnel.customFields.types.text', 'Texto')}</SelectItem>
                <SelectItem value="selecao">{t('funnel.customFields.types.selection', 'Seleção')}</SelectItem>
                <SelectItem value="data">{t('funnel.customFields.types.date', 'Data')}</SelectItem>
                <SelectItem value="upload">{t('funnel.customFields.types.uploadFile', 'Upload de arquivo')}</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {tipo === 'selecao' && (
            <div className={D.field}>
              <label className={D.label}>{t('funnel.customFields.modal.optionsLabel', 'Opções')}</label>
              <div className="flex flex-wrap gap-1.5 mb-2.5">
                {opcoes?.map((opcao, index) => (
                  <span key={index} className={D.chip}>
                    {opcao}
                    <button
                      type="button"
                      onClick={() => removerOpcao(index)}
                      className={D.chipRemove}
                      aria-label="Remover"
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
              <div className="flex gap-2">
                <Input
                  value={novaOpcao}
                  onChange={(e) => setNovaOpcao(e.target.value)}
                  placeholder={t('funnel.customFields.modal.newOptionPlaceholder', 'Nova opção')}
                  onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), adicionarOpcao())}
                  className={`${D.input} flex-1`}
                />
                <button type="button" className={D.ghostButton} onClick={adicionarOpcao}>
                  {t('buttons.add', 'Adicionar', { ns: 'common' })}
                </button>
              </div>
            </div>
          )}

          <div className={`${D.toggleRow} border-t border-[#f0f0f3]`}>
            <div className={D.toggleRowMain}>
              <p className={D.toggleRowLabel}>
                {t('funnel.customFields.modal.requiredLabel', 'Campo obrigatório')}
              </p>
              <p className={D.toggleRowHelp}>
                {t('funnel.customFields.modal.requiredHint', 'Impede salvar o negócio sem preencher este campo.')}
              </p>
            </div>
            <Switch
              className={D.switch}
              checked={obrigatorio}
              onCheckedChange={changeObrigatorio}
            />
          </div>
        </div>
        <DialogFooter className={D.dialogFooter}>
          <button type="button" className={D.ghostButton} onClick={onClose}>
            {t('buttons.cancel', { ns: 'common' })}
          </button>
          <button type="button" className={D.primaryButton} onClick={onSubmit}>
            {action === 'Criar' ? t('buttons.create', 'Criar', { ns: 'common' }) : t('buttons.save', 'Salvar', { ns: 'common' })}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
